import { render, staticRenderFns } from "./VotingIdeasContentWrapper.vue?vue&type=template&id=26cb17f1&scoped=true&"
import script from "./VotingIdeasContentWrapper.vue?vue&type=script&lang=js&"
export * from "./VotingIdeasContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VotingIdeasContentWrapper.vue?vue&type=style&index=0&id=26cb17f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb17f1",
  null
  
)

export default component.exports